<meta http-equiv="Cache-Control" content="no-cache, no-store, must-revalidate" />
<meta http-equiv="Pragma" content="no-cache" />
<meta http-equiv="Expires" content="0" />

<app-agent-nav-bar />

<div class="main-content" (click)="mainContentClick()">
  @if (resources) {
    <router-outlet />
  }
</div>

<div [ngClass]="{ 'search-result-backdrop active': showSearchPopup }"></div>
